<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 v-if="$auth.hasRole(['COMPANY_ADMIN', 'COMPANY_USER'], true)"  class="my-2">
        <v-card>
          <v-card-title>
            {{ $t('dashboard.lastRecordings') }}
          </v-card-title>
          <v-divider />
          <v-card-text>
            <records :paginating="false" :filtering="false" :exportable="false" :perPage="6" />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn flat to="/recordings"ř>{{ $t('dashboard.moreRecordings') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex v-if="$auth.hasRole(['SUPER_ADMIN', 'COMPANY_ADMIN', 'GROUP_ADMIN'])"  class="my-2">
        <v-card>
          <v-card-title>{{ $t('dashboard.notifications') }}</v-card-title>
          <v-divider />
          <v-card-text><notifications :small="true" /></v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 v-if="$auth.hasRole('SUPER_ADMIN')"  class="my-2">
        <v-card>
          <v-card-title>{{ $t('dashboard.systemStorageUsage') }}</v-card-title>
          <v-divider />
          <v-card-text><system-storage-report :small="true" /></v-card-text>
        </v-card>
      </v-flex>

      <v-flex
        v-if="$auth.hasRole(['GROUP_ADMIN', 'COMPANY_ADMIN'])"
        :class="{ 'my-2': true, xs3: $auth.hasRole('COMPANY_ADMIN'), xs4: $auth.hasRole('GROUP_ADMIN') }"
      >
        <v-card>
          <v-card-title>{{ $t('dashboard.logicStorageUsage') }}</v-card-title>
          <v-divider />
          <v-card-text><logic-storage-report :small="true" :size="$auth.hasRole('GROUP_ADMIN') ? 300 : 250" /></v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Records from '@/components/Records'
import SystemStorageReport from '@/components/Reports/SystemStorageReport'
import LogicStorageReport from '@/components/Reports/LogicStorageReport'
import Notifications from '@/components/Reports/Notifications'

export default {
  components: {
    Records,
    SystemStorageReport,
    LogicStorageReport,
    Notifications
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Dashboard.vue?2ba06a5a